Ext.define('SA.ConstrainedSize', {
    singleton: true,

    get({intrinsicSize, maxSize}) {
        var {width: scrollbarWidth, height: scrollbarHeight} = Ext.getScrollbarSize(),
            {width: maxWidth, height: maxHeight} = maxSize,
            {width: intrinsicWidth, height: intrinsicHeight} = intrinsicSize,
            overflowsWidth = intrinsicWidth > maxWidth,
            overflowsHeight = intrinsicHeight > maxHeight,
            width, height;

        if (overflowsWidth && overflowsHeight) {
            width = maxWidth;
            height = maxHeight;
        }
        else if (!overflowsWidth && !overflowsHeight) {
            width = intrinsicWidth;
            height = intrinsicHeight;
        }
        else if (overflowsWidth) {
            width = maxWidth;

            overflowsHeight = (intrinsicHeight + scrollbarHeight) > maxHeight;
            height = overflowsHeight ? maxHeight : (intrinsicHeight + scrollbarHeight);
        }
        else {
            height = maxHeight;

            overflowsWidth = (intrinsicWidth + scrollbarWidth) > maxWidth;
            width = overflowsWidth ? maxWidth : (intrinsicWidth + scrollbarWidth);
        }

        return {
            size: {width, height},
            hasScrollX: overflowsWidth,
            hasScrollY: overflowsHeight,
            extraSpace: {width: maxWidth - width, height: maxHeight - height}
        };
    }
});